import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { DiplomeStats } from '../../../service/coursera-dashboard-stats.model';
import { Chart, ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-coursera-diplome-chart',
  templateUrl: './coursera-diplome-chart.component.html',
  styleUrls: ['./coursera-diplome-chart.component.css'],
})
export class CourseraDiplomeChartComponent implements OnChanges {
  @Input() data: DiplomeStats[] = [];
  @ViewChild('diplomeChart') chartRef!: ElementRef;

  chart!: Chart;

  ngOnChanges(): void {
    // 🔥 si pas de données → ne rien faire (noData côté template)
    if (!this.data || this.data.length === 0) return;

    // 🔥 attendre que le canvas soit présent (ngIf)
    setTimeout(() => {
      this.createChart();
    });
  }

  createChart() {
    if (!this.chartRef?.nativeElement) return;

    const ctx = this.chartRef.nativeElement.getContext('2d');

    const labels = this.data.map((d) => d.diplome);
    const values = this.data.map((d) => d.total);

    if (this.chart) {
      this.chart.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            data: values,
          },
        ],
      },
      options: {
        responsive: true,
      },
    };

    this.chart = new Chart(ctx, config);
  }
}
